export default {
  URL_LOGIN: '/api/user/login',
  URL_REGISTER: '/api/user/register',
  URL_GET_USER: '/api/user?gateway=true',
  URL_UPDATE_USER: '/api/user/:userID',
  URL_UPDATE_USER_PASSWORD: '/api/user/:userID/password',
  URL_FORGOT_PASSWORD: '/api/user/forgot-password',
  URL_START_SESSION: '/api/user/startGatewayStripeSession',
  URL_OPEN_PORTAL: '/api/user/openGatewayStripePortal',
  URL_FETCH_PRODUCTS: '/api/trainer/:trainerID/products'
}
